import apiManager from './apiManager'
const deleteCertificate = async (id) => {
	const deleteCreatedCertificate = apiManager.axios
		.delete(`/v1/admin/agent/certificate/${id}`)
		.then((response) => {
			return {
				status: 200,
				data: response.data.data,
			}
		})
		.catch((err) => {
			return {
				status: err.response.status,
			}
		})
	return deleteCreatedCertificate
}

const getAllCertificateName = async () => {
	const getCertificate = apiManager.axios
		.get(`/v1/admin/agent/certificateNames`)
		.then((response) => {
			return {
				status: 200,
				data: response.data.data,
			}
		})
		.catch((err) => {
			return {
				status: err.response.status,
			}
		})
	return getCertificate
}

const postNewCertificateName = async (createObj) => {
	const createCertificate = apiManager.axios
		.post(`/v1/admin/agent/certificateNames`, createObj)
		.then((response) => {
			return {
				status: 200,
				data: response.data.data,
			}
		})
		.catch((err) => {
			return {
				status: err.response.status,
			}
		})
	return createCertificate
}
export default {
	getAllCertificateName,
	postNewCertificateName,
	deleteCertificate,
}
